(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["promo-media"] && !Shopify.designMode) return;
  try {
    /**
   * Swap promo videos for their poster stills while a cross-document view
   * transition captures the outgoing page. WebKit snapshots a playing
   * <video> as a blank white region, which the page dissolve would
   * otherwise fade out as a white flash; the poster stands in for the video
   * in that snapshot only.
   *
   * The flag is set on `pageswap` (fires just before the outgoing snapshot)
   * and cleared on `pagehide` (fires just after it, before the page freezes
   * into the back/forward cache) so a restored page never comes back with
   * the poster showing. The restore path (`pageshow`) is deliberately left
   * untouched — running work there disturbs scroll restoration.
   * @returns {void}
   */
  (function bindPromoMediaTransitionCapture() {
    if (window.__promoMediaTransitionCaptureBound) return;
    window.__promoMediaTransitionCaptureBound = true;

    window.addEventListener('pageswap', (event) => {
      if (event.viewTransition) {
        document.documentElement.setAttribute('data-vt-capture', '');
      }
    });

    window.addEventListener('pagehide', () => {
      document.documentElement.removeAttribute('data-vt-capture');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
